var _polygon;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSquare = function SvgSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.7 12.88 6.25 12.88 6.25 2.62 1.8 2.62 1.8 7.17 0.3 7.17 0.3 1.12 7.75 1.12 7.75 11.38 12.2 11.38 12.2 6.83 13.7 6.83 13.7 12.88"
  })));
};

export default SvgSquare;